import React from 'react'
import { Modal, Button, Alert, Card, Row, Col, Badge } from 'react-bootstrap'

const StageAsrModal = ({ show, onHide, workStage, projectId }) => {
  if (!workStage) return null

  const allAsrRecords = []
  if (workStage.works && workStage.works.length > 0) {
    workStage.works.forEach((work) => {
      if (work.asr_record) {
        allAsrRecords.push({
          asrRecord: work.asr_record,
          workName: work.work_name,
        })
      }
    })
  }

  const handleDownloadPdf = () => {
    const url = `/projects/${projectId}/work_stages/${workStage.id}/stage_asr.pdf`
    window.open(url, '_blank')
  }

  return (
    <Modal show={show} onHide={onHide} size="xl">
      <Modal.Header closeButton className="bg-secondary bg-opacity-10 border-0 pb-3">
        <div className="d-flex flex-column">
          <Modal.Title className="mb-1 fw-bold">
            <i className="bi bi-file-earmark-text me-2"></i>
            Акты скрытых работ этапа
          </Modal.Title>
          <small className="text-muted">{workStage.work_stage_name}</small>
        </div>
      </Modal.Header>
      <Modal.Body className="p-4">
        {allAsrRecords.length > 0 ? (
          <div className="mb-4">
            <div className="d-flex align-items-center mb-3">
              <i className="bi bi-file-earmark-check fs-5 text-secondary me-2"></i>
              <h6 className="mb-0 fw-semibold">
                Всего актов: {allAsrRecords.length}
              </h6>
            </div>
            <div className="d-flex flex-column gap-3">
              {allAsrRecords.map((record, index) => (
                <Card key={`${record.workName}-${index}`} className="border shadow-sm">
                  <Card.Body className="p-3">
                    <div className="d-flex flex-column gap-2">
                      <div className="d-flex align-items-start justify-content-between">
                        <div className="flex-grow-1">
                          <h6 className="fw-semibold mb-2">
                            <Badge bg="secondary" className="me-2">
                              {index + 1}
                            </Badge>
                            {record.workName}
                          </h6>
                          {record.asrRecord.comment && (
                            <div className="mb-2">
                              <small className="text-muted fw-semibold d-block mb-1">
                                Комментарий:
                              </small>
                              <p className="mb-0 text-muted small">
                                {record.asrRecord.comment}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                      {record.asrRecord.documents && record.asrRecord.documents.length > 0 && (
                        <div>
                          <small className="text-muted fw-semibold d-block mb-2">
                            Документы: {record.asrRecord.documents.length}
                          </small>
                          <Row className="g-2">
                            {record.asrRecord.documents.map((doc, docIndex) => (
                              <Col key={docIndex} xs={6} md={4} lg={3}>
                                <Card className="border">
                                  {doc.thumbnail_url ? (
                                    <Card.Img
                                      variant="top"
                                      src={doc.thumbnail_url}
                                      style={{ height: '120px', objectFit: 'cover' }}
                                      loading="lazy"
                                    />
                                  ) : (
                                    <div
                                      className="d-flex align-items-center justify-content-center bg-light"
                                      style={{ height: '120px' }}
                                    >
                                      <i className="bi bi-file-earmark-pdf fs-1 text-muted"></i>
                                    </div>
                                  )}
                                  <Card.Body className="p-2">
                                    <small className="text-truncate d-block" title={doc.filename}>
                                      {doc.filename}
                                    </small>
                                  </Card.Body>
                                </Card>
                              </Col>
                            ))}
                          </Row>
                        </div>
                      )}
                    </div>
                  </Card.Body>
                </Card>
              ))}
            </div>
          </div>
        ) : (
          <Alert variant="light" className="border text-center py-4 mb-4">
            <i className="bi bi-file-earmark-x fs-3 text-muted d-block mb-2"></i>
            <p className="mb-0 text-muted">
              В работах этого этапа еще не добавлены акты скрытых работ
            </p>
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0 pb-4 px-4">
        {allAsrRecords.length > 0 && (
          <Button variant="primary" onClick={handleDownloadPdf}>
            <i className="bi bi-file-pdf me-2"></i>
            Скачать PDF
          </Button>
        )}
        <Button variant="outline-secondary" onClick={onHide}>
          <i className="bi bi-x-lg me-2"></i>
          Закрыть
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default StageAsrModal